"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchBillDetailsReducer = exports.fetchOutletSummaryForOutletReducer = exports.fetchOutletwiseSummaryReducer = exports.fetchOutletwiseSummaryForFranchiseReducer = exports.downloadReportsReducer = exports.fetchPaymentwiseReportReducer = exports.fetchDuplicateBillReportReducer = exports.fetchWriteOffReportReducer = exports.fetchCounterWiseReportReducer = exports.fetchUserwiseReportReducer = exports.fetchInventoryReportReducer = exports.fetchItemWiseReportReducer = exports.fetchDaywiseReportReducer = exports.fetchBillwiseReportReducer = exports.fetchOutletSummaryReducer = exports.fetchBusinessSummaryReducer = exports.fetchBusinessSummaryCurrentReducer = exports.fetchBillDetailsSlice = exports.downloadReportsSlice = exports.fetchPaymentwiseReportSlice = exports.fetchDuplicateBillReportSlice = exports.fetchWriteOffReportSlice = exports.fetchCounterWiseReportSlice = exports.fetchUserwiseReportSlice = exports.fetchInventoryReportSlice = exports.fetchItemWiseReportSlice = exports.fetchDaywiseReportSlice = exports.fetchBillwiseReportSlice = exports.fetchOutletSummaryForOutletSlice = exports.fetchOutletSummaryForFranchiseSlice = exports.fetchOutletwiseSummarySlice = exports.fetchOutletSummarySlice = exports.fetchBusinessSummarySlice = exports.fetchBusinessSummaryCurrentSlice = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const reportsAction_1 = require("./reportsAction");
const fetchBusinessSummaryCurrentInitialState = {
    loading: false,
    error: null,
    data: []
};
const fetchBusinessSummaryInitialState = {
    loading: false,
    error: null,
    data: []
};
const fetchOutletSummaryInitialState = {
    loading: false,
    error: null,
    data: []
};
const fetchBillwiseReportInitialState = {
    loading: false,
    error: null,
    data: []
};
const fetchBillDetailsInitialState = {
    loading: false,
    error: null,
    data: []
};
const fetchDaywiseReportInitialState = {
    loading: false,
    error: null,
    data: []
};
const fetchItemWiseReportInitialState = {
    loading: false,
    error: null,
    data: []
};
const fetchInventoryReportInitialState = {
    loading: false,
    error: null,
    data: []
};
const fetchUserwiseReportInitialState = {
    loading: false,
    error: null,
    data: []
};
const fetchCounterWiseReportInitialState = {
    loading: false,
    error: null,
    data: []
};
const fetchWriteOffReportInitialState = {
    loading: false,
    error: null,
    data: []
};
const fetchDuplicateBillReportInitialState = {
    loading: false,
    error: null,
    data: []
};
const fetchPaymentwiseReportInitialState = {
    loading: false,
    error: null,
    data: []
};
const fetchDownloadReportInitialState = {
    loading: false,
    error: null,
    data: []
};
exports.fetchBusinessSummaryCurrentSlice = (0, toolkit_1.createSlice)({
    name: 'reports/fetchBusinessSummaryCurrent',
    initialState: fetchBusinessSummaryCurrentInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(reportsAction_1.fetchBusinessSummaryCurrent.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(reportsAction_1.fetchBusinessSummaryCurrent.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        });
        builder.addCase(reportsAction_1.fetchBusinessSummaryCurrent.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });
    }
});
exports.fetchBusinessSummarySlice = (0, toolkit_1.createSlice)({
    name: 'reports/fetchBusinessSummary',
    initialState: fetchBusinessSummaryInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(reportsAction_1.fetchBusinessSummary.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(reportsAction_1.fetchBusinessSummary.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        });
        builder.addCase(reportsAction_1.fetchBusinessSummary.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });
    }
});
exports.fetchOutletSummarySlice = (0, toolkit_1.createSlice)({
    name: 'reports/fetchOutletSummary',
    initialState: fetchOutletSummaryInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(reportsAction_1.fetchOutletSummary.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(reportsAction_1.fetchOutletSummary.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        });
        builder.addCase(reportsAction_1.fetchOutletSummary.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });
    }
});
exports.fetchOutletwiseSummarySlice = (0, toolkit_1.createSlice)({
    name: 'reports/fetchOutletwiseSummary',
    initialState: fetchOutletSummaryInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(reportsAction_1.fetchOutletwiseSummary.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(reportsAction_1.fetchOutletwiseSummary.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        });
        builder.addCase(reportsAction_1.fetchOutletwiseSummary.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });
    }
});
exports.fetchOutletSummaryForFranchiseSlice = (0, toolkit_1.createSlice)({
    name: 'reports/fetchOutletSummary',
    initialState: fetchOutletSummaryInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(reportsAction_1.fetchOutletwiseSummaryForFranchise.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(reportsAction_1.fetchOutletwiseSummaryForFranchise.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        });
        builder.addCase(reportsAction_1.fetchOutletwiseSummaryForFranchise.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });
    }
});
// Slice for dashboard
exports.fetchOutletSummaryForOutletSlice = (0, toolkit_1.createSlice)({
    name: 'reports/fetchOutletSummaryForOutlet',
    initialState: fetchOutletSummaryInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(reportsAction_1.fetchOutletwiseSummaryForOutlet.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(reportsAction_1.fetchOutletwiseSummaryForOutlet.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        });
        builder.addCase(reportsAction_1.fetchOutletwiseSummaryForOutlet.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });
    }
});
exports.fetchBillwiseReportSlice = (0, toolkit_1.createSlice)({
    name: 'reports/fetchBillwiseReport',
    initialState: fetchBillwiseReportInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(reportsAction_1.fetchBillwiseReport.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(reportsAction_1.fetchBillwiseReport.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        });
        builder.addCase(reportsAction_1.fetchBillwiseReport.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });
    }
});
exports.fetchDaywiseReportSlice = (0, toolkit_1.createSlice)({
    name: 'reports/fetchDaywiseReport',
    initialState: fetchDaywiseReportInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(reportsAction_1.fetchDaywiseReport.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(reportsAction_1.fetchDaywiseReport.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        });
        builder.addCase(reportsAction_1.fetchDaywiseReport.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });
    }
});
exports.fetchItemWiseReportSlice = (0, toolkit_1.createSlice)({
    name: 'reports/fetchItemWiseReport',
    initialState: fetchItemWiseReportInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(reportsAction_1.fetchItemWiseReport.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(reportsAction_1.fetchItemWiseReport.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        });
        builder.addCase(reportsAction_1.fetchItemWiseReport.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });
    }
});
exports.fetchInventoryReportSlice = (0, toolkit_1.createSlice)({
    name: 'reports/fetchInventoryReport',
    initialState: fetchInventoryReportInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(reportsAction_1.fetchInventoryReport.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(reportsAction_1.fetchInventoryReport.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        });
        builder.addCase(reportsAction_1.fetchInventoryReport.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });
    }
});
exports.fetchUserwiseReportSlice = (0, toolkit_1.createSlice)({
    name: 'reports/fetchUserwiseReport',
    initialState: fetchUserwiseReportInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(reportsAction_1.fetchUserwiseReport.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(reportsAction_1.fetchUserwiseReport.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        });
        builder.addCase(reportsAction_1.fetchUserwiseReport.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });
    }
});
exports.fetchCounterWiseReportSlice = (0, toolkit_1.createSlice)({
    name: 'reports/fetchCounterWiseReport',
    initialState: fetchCounterWiseReportInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(reportsAction_1.fetchCounterWiseReport.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(reportsAction_1.fetchCounterWiseReport.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        });
        builder.addCase(reportsAction_1.fetchCounterWiseReport.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });
    }
});
exports.fetchWriteOffReportSlice = (0, toolkit_1.createSlice)({
    name: 'reports/fetchWriteOffReport',
    initialState: fetchWriteOffReportInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(reportsAction_1.fetchWriteOffReport.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(reportsAction_1.fetchWriteOffReport.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        });
        builder.addCase(reportsAction_1.fetchWriteOffReport.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });
    }
});
exports.fetchDuplicateBillReportSlice = (0, toolkit_1.createSlice)({
    name: 'reports/fetchDuplicateBillReport',
    initialState: fetchDuplicateBillReportInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(reportsAction_1.fetchDuplicateBillReport.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(reportsAction_1.fetchDuplicateBillReport.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        });
        builder.addCase(reportsAction_1.fetchDuplicateBillReport.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });
    }
});
exports.fetchPaymentwiseReportSlice = (0, toolkit_1.createSlice)({
    name: 'reports/fetchPaymentwiseReport',
    initialState: fetchPaymentwiseReportInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(reportsAction_1.fetchPaymentwiseReport.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(reportsAction_1.fetchPaymentwiseReport.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        });
        builder.addCase(reportsAction_1.fetchPaymentwiseReport.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });
    }
});
exports.downloadReportsSlice = (0, toolkit_1.createSlice)({
    name: 'reports/fetchDownloadReport',
    initialState: fetchDownloadReportInitialState,
    reducers: {
        reset: () => fetchDownloadReportInitialState
    },
    extraReducers: (builder) => {
        builder.addCase(reportsAction_1.fetchDownloadReport.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(reportsAction_1.fetchDownloadReport.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        });
        builder.addCase(reportsAction_1.fetchDownloadReport.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });
    }
});
exports.fetchBillDetailsSlice = (0, toolkit_1.createSlice)({
    name: 'reports/fetchBillDetails',
    initialState: fetchBillDetailsInitialState,
    reducers: {
        reset: () => fetchBillDetailsInitialState
    },
    extraReducers: (builder) => {
        builder.addCase(reportsAction_1.fetchBillDetails.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(reportsAction_1.fetchBillDetails.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        });
        builder.addCase(reportsAction_1.fetchBillDetails.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });
    }
});
exports.fetchBusinessSummaryCurrentReducer = exports.fetchBusinessSummaryCurrentSlice.reducer;
exports.fetchBusinessSummaryReducer = exports.fetchBusinessSummarySlice.reducer;
exports.fetchOutletSummaryReducer = exports.fetchOutletSummarySlice.reducer;
exports.fetchBillwiseReportReducer = exports.fetchBillwiseReportSlice.reducer;
exports.fetchDaywiseReportReducer = exports.fetchDaywiseReportSlice.reducer;
exports.fetchItemWiseReportReducer = exports.fetchItemWiseReportSlice.reducer;
exports.fetchInventoryReportReducer = exports.fetchInventoryReportSlice.reducer;
exports.fetchUserwiseReportReducer = exports.fetchUserwiseReportSlice.reducer;
exports.fetchCounterWiseReportReducer = exports.fetchCounterWiseReportSlice.reducer;
exports.fetchWriteOffReportReducer = exports.fetchWriteOffReportSlice.reducer;
exports.fetchDuplicateBillReportReducer = exports.fetchDuplicateBillReportSlice.reducer;
exports.fetchPaymentwiseReportReducer = exports.fetchPaymentwiseReportSlice.reducer;
exports.downloadReportsReducer = exports.downloadReportsSlice.reducer;
exports.fetchOutletwiseSummaryForFranchiseReducer = exports.fetchOutletSummaryForFranchiseSlice.reducer;
exports.fetchOutletwiseSummaryReducer = exports.fetchOutletwiseSummarySlice.reducer;
exports.fetchOutletSummaryForOutletReducer = exports.fetchOutletSummaryForOutletSlice.reducer;
exports.fetchBillDetailsReducer = exports.fetchBillDetailsSlice.reducer;
const fetchWaiterItemWiseReportInitialState = { loading: false, error: null, data: [] };
const fetchWaiterCommissionReportInitialState = { loading: false, error: null, data: [] };
const fetchWaiterMonthWiseReportInitialState = { loading: false, error: null, data: [] };
const fetchWaiterSalesReportInitialState = { loading: false, error: null, data: [] };
exports.fetchWaiterItemWiseReportSlice = (0, toolkit_1.createSlice)({
    name: 'reports/fetchWaiterItemWiseReport',
    initialState: fetchWaiterItemWiseReportInitialState,
    reducers: {
        clearWaiterItemWiseState: (state) => {
            state.loading = false;
            state.error = null;
            state.data = [];
        }
    },
    extraReducers: (builder) => {
        builder.addCase(reportsAction_1.fetchWaiterItemWiseReport.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(reportsAction_1.fetchWaiterItemWiseReport.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        });
        builder.addCase(reportsAction_1.fetchWaiterItemWiseReport.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });
    }
});
exports.fetchWaiterCommissionReportSlice = (0, toolkit_1.createSlice)({
    name: 'reports/fetchWaiterCommissionReport',
    initialState: fetchWaiterCommissionReportInitialState,
    reducers: {
        clearWaiterCommissionState: (state) => {
            state.loading = false;
            state.error = null;
            state.data = [];
        }
    },
    extraReducers: (builder) => {
        builder.addCase(reportsAction_1.fetchWaiterCommissionReport.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(reportsAction_1.fetchWaiterCommissionReport.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        });
        builder.addCase(reportsAction_1.fetchWaiterCommissionReport.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });
    }
});
exports.fetchWaiterMonthWiseReportSlice = (0, toolkit_1.createSlice)({
    name: 'reports/fetchWaiterMonthWiseReport',
    initialState: fetchWaiterMonthWiseReportInitialState,
    reducers: {
        clearWaiterMonthWiseState: (state) => {
            state.loading = false;
            state.error = null;
            state.data = [];
        }
    },
    extraReducers: (builder) => {
        builder.addCase(reportsAction_1.fetchWaiterMonthWiseReport.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(reportsAction_1.fetchWaiterMonthWiseReport.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        });
        builder.addCase(reportsAction_1.fetchWaiterMonthWiseReport.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });
    }
});
exports.fetchWaiterSalesReportSlice = (0, toolkit_1.createSlice)({
    name: 'reports/fetchWaiterSalesReport',
    initialState: fetchWaiterSalesReportInitialState,
    reducers: {
        clearWaiterSalesState: (state) => {
            state.loading = false;
            state.error = null;
            state.data = [];
        }
    },
    extraReducers: (builder) => {
        builder.addCase(reportsAction_1.fetchWaiterSalesReport.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(reportsAction_1.fetchWaiterSalesReport.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        });
        builder.addCase(reportsAction_1.fetchWaiterSalesReport.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });
    }
});
exports.clearWaiterItemWiseState = exports.fetchWaiterItemWiseReportSlice.actions.clearWaiterItemWiseState;
exports.clearWaiterCommissionState = exports.fetchWaiterCommissionReportSlice.actions.clearWaiterCommissionState;
exports.clearWaiterMonthWiseState = exports.fetchWaiterMonthWiseReportSlice.actions.clearWaiterMonthWiseState;
exports.clearWaiterSalesState = exports.fetchWaiterSalesReportSlice.actions.clearWaiterSalesState;
exports.fetchWaiterItemWiseReportReducer = exports.fetchWaiterItemWiseReportSlice.reducer;
exports.fetchWaiterCommissionReportReducer = exports.fetchWaiterCommissionReportSlice.reducer;
exports.fetchWaiterMonthWiseReportReducer = exports.fetchWaiterMonthWiseReportSlice.reducer;
exports.fetchWaiterSalesReportReducer = exports.fetchWaiterSalesReportSlice.reducer;
